<template>
    <v-container grid-list-md fluid>
        <div class="white-card">
            <div class="content-body">
                <h1 class="content-title">Suggest Discussion Topics</h1>                
                <div style="text-align:center;font-weight:bold;">Communication is an essential part of community.</div>
                <div style="text-align:center;">We are developing discussions here so members can discuss important topics and grow together. <br/> When it's ready, you will be able to lurk and talk all you want.</div>
                <iframe src="https://services.cognitoforms.com/f/u5vx8UXMRU-V5VTTzNYvcg?id=7" style="position:relative;width:1px;min-width:100%;*width:100%;" frameborder="0" scrolling="yes" seamless="seamless" height="646" width="100%"></iframe>
            </div>
        </div>
    </v-container>
</template>

<script>
    export default {
        name: "DiscussionsList",
        props: {
            // msg: String
        },
        computed: {
            /*
            * Method to check that request is authenticated or not
            */
            isAuthenticated() {
                return this.$store.getters.isAuthenticated;
            },
        },
        methods: {
            /*
            * Method to redirect specific path
            */
            goToPath(path) {
                this.$router.push(path);
            }
        },
        mounted() {
            let recaptchaScript = document.createElement('script')
            recaptchaScript.setAttribute('src', 'https://services.cognitoforms.com/scripts/embed.js')
            document.head.appendChild(recaptchaScript)
        }, 
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
    .mmp-title {
        text-align:center;
        font-size:48px;
        font-weight:bold;
        margin-bottom:10px;
    }
    .greeting {
        margin: auto;
    }
    .content-title {
        text-align:center;
        font-size:32px;
        font-weight:bold;
    }
    .content-subTitle {
        padding-left: 10px;
        font-size:24px;
        font-weight:bold; 
    }
    .content-body {
        padding: 10px;
        font-size:18px;        
    }
</style>
